import { connect } from 'react-redux'
import { goToLobby, message } from '../../redux/actions'
import Component from '../component'

/**
 * This is the home prompt, when the player wants
 * to close the game and go back to the lobby,
 * using the home button.
 */
@connect(state => ({ base: state.base }), { message, goToLobby })
export default class HomePrompt extends Component {
  /**
   * Closes the message and redirect player to lobby if
   * "yes" was chosen.
   * @param {boolean} choice - "Yes" or "No" choice
   * @param {object} e - Button event
   * @returns {boolean}
   */
  homeAction = (choice, e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!choice) {
      setTimeout(() => {
        this.props.message(null)
      }, 10)
    } else
      this.props.goToLobby()

    return false
  }

  /**
   * Renders out a message popup as DOM element, displaying
   * a yes or no question.
   * @returns {*}
   */
  render() {
    return (
      <div className="popup-content">
        <div className="popup-message">
          {this.t('prompt.homeButton')}
        </div>

        <br />

        <div className="buttonContainer two-col">
          <button id="no" onClick={e => { this.homeAction(false, e) }}>{this.t('soundPrompt.mute')}</button>
          <button id="yes" onClick={e => { this.homeAction(true, e) }}>{this.t('soundPrompt.usesounds')}</button>
        </div>
      </div>
    )
  }
}
